export const environment = {
    production: false,
    config: {
        empresa: {
            emp: 18,
            dominioEmp: '@transbus.srv.br',
            emailEmp: 'suporte@transbus.srv.br',
            termoPrivacy: 'https://ngsservicos.com/aplicativos/NgFuncionario/transbus/arquivos/transbusInfo.html',
            htmlVersao: 'https://ngsservicos.com/aplicativos/NgFuncionario/transbus/versao/news',
            htmlInfoMedalha: '',
            versaoApp: '1.2.7',
            nomeApp: 'Transbus Info',
            versaoMenu: 'V1',
            nomeEmpresa: 'Transbus',
            baseUrl: ''
        },
        firebase: {
            apiKey: "AIzaSyAYLKfQCF7M4vMPfzWwXHnjCwRu1YzCEAc",
            authDomain: "apptransbus.firebaseapp.com",
            projectId: "apptransbus",
            storageBucket: "apptransbus.appspot.com",
            messagingSenderId: "320635204109",
            appId: "1:320635204109:web:ad6aeb603f7b0738975b44",
            measurementId: "G-WNN8JYWCC8"
        },
        mensagens: {
            msgRecSenha: 'E-mail não encontrado! Procure a empresa para atualizar o seu e-mail.',
            msgRecSenha2: 'Você receberá em alguns minutos um e-mail com a nova senha de acesso. Qualquer dúvida entrar em contato com a empresa.'
        },
        style: {
            logoEmpresa: 'https://ngsservicos.com/aplicativos/NgFuncionario/transbus/imagens/logoEmp.png',
            logoEmpresa2: '',
            iconeApp: 'https://ngsservicos.com/aplicativos/NgFuncionario/transbus/imagens/icon.png',
            iconeApp2: '',
            corEmpresa: 'color29',
            corMenu: 'color21',
            corMenu1: 'color22',
            corMenu2: 'color21',
            varCSS: 'logoTransbus',
            varCSS2: '',
            varCSS3: 'scroll-content',
            varCSS4: 'img-menu-transbus'
        }
    }
};
